onDomReady(function() {
   const toggles = document.querySelectorAll('.js-slide-toggle');

   const onClick = ev => {
      var el = ev.currentTarget;
      var dropdown = el.getNext('.js-slide-drawer');
      if (window.innerWidth < 600) {
         if (dropdown.getStyle('height') == '0px') {
            TweenMax.set(dropdown, { height: 'auto' });
            TweenMax.from(dropdown, 0.2, { height: 0 });
            el.addClass('drawer-open');
         } else {
            TweenMax.to(dropdown, 0.2, { height: 0 });
            el.removeClass('drawer-open');
         }
      }
   };

   for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', onClick);
   }
});
